<script>
import button from '../mixins/button';
import iconImg from '../images/zoom-out.png';

export default {
    name: 'ZoomIn',
    mixins: [button],
    data() {
        return {
            name: 'ZoomOut',
            icon: 'el-icon-zoom-out',
            toolTipText: {
                // 工具提示
                zh: '缩小', // 中文
                en: 'Zoom Out', // 英文
            },
            iconImage: iconImg,
            iconImageActive: iconImg,
            color: {
                enabled: '#1d212d',
                active: '#2e7df8',
                disabled: 'gray',
            },
            styles: {
                // fontSize: '24px',
            },
        };
    },
    methods: {
        execute() {
            this.$parent.zoomOut();
        },
    },
};
</script>
